module.exports = __webpack_public_path__ + "static/sport/bgi-btn.0954db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/bgi-btn.png
// module id = /q0s
// module chunks = 0